import { Component } from '@angular/core';
import { AdminStockList } from '../../../components/admin-dashboard-component/admin-stock-list/admin-stock-list';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-stock-management',
  imports: [RouterModule],
  templateUrl: './stock-management.html',
  styleUrl: './stock-management.scss',
})
export class StockManagement {}
